import React, { useState } from 'react';
import { Box, Button, Flex } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Alert, AlertDescription, AlertTitle, FormActions, FormRow, FormSection } from '../../ui';
import { useActionToast, useFormValidationToast } from '../../../services/actionToast';
import { api } from '../../../services/api';
import { removeAuthStorage } from '../../../services/storage';
import { passwordConfirmationField, passwordField } from '../../../utils/passwordValidation';
import { PasswordInputForm } from '../../inputs/forms/PasswordInputForm';

const schema = Yup.object().shape({
  current_password: Yup.string().required('Este campo é obrigatório!'),
  new_password: passwordField,
  confirmation: passwordConfirmationField,
});

export default function PasswordManagementForm() {
  const validationToast = useFormValidationToast();
  const toast = useActionToast();
  const navigate = useNavigate();
  const [serverError, setServerError] = useState('');
  const [success, setSuccess] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: { current_password: '', new_password: '', confirmation: '' },
  });

  const onSubmit = async (values: any) => {
    setServerError('');
    try {
      await api.post('/auth/change-password', values);
      await removeAuthStorage();
      setSuccess(true);
      toast({
        status: 'success',
        title: 'Senha alterada',
        description: 'Entre novamente para continuar.',
      });
    } catch {
      const feedback =
        'Não foi possível alterar a senha. Verifique a senha atual e tente novamente.';
      setServerError(feedback);
      toast({ status: 'error', title: 'Senha não alterada', description: feedback });
    }
  };

  if (success) {
    return (
      <FormSection title="Gerenciar senha">
        <Alert variant="success" data-testid="change-password-success">
          <AlertTitle>Senha alterada com sucesso.</AlertTitle>
          <AlertDescription>Entre novamente para continuar.</AlertDescription>
        </Alert>
        <Flex>
          <Button onClick={() => navigate('/login', { replace: true })}>Ir para o login</Button>
        </Flex>
      </FormSection>
    );
  }

  return (
    <FormSection title="Gerenciar senha" description="A alteração encerra todas as sessões ativas.">
      <Box
        as="form"
        noValidate
        onSubmit={handleSubmit(onSubmit, validationToast)}
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <FormRow>
          <PasswordInputForm
            name="current_password"
            label="Senha atual"
            register={register}
            errors={errors}
            isRequired
            autoComplete="current-password"
          />
          <PasswordInputForm
            name="new_password"
            label="Nova senha"
            register={register}
            errors={errors}
            isRequired
            autoComplete="new-password"
          />
          <PasswordInputForm
            name="confirmation"
            label="Confirmar nova senha"
            register={register}
            errors={errors}
            isRequired
            autoComplete="new-password"
          />
        </FormRow>
        {serverError && (
          <Alert variant="error">
            <AlertDescription>{serverError}</AlertDescription>
          </Alert>
        )}
        <FormActions isLoading={isSubmitting} submitLabel="Alterar senha" />
      </Box>
    </FormSection>
  );
}
